import { computed } from "vue";
import { getLinkTarget } from "../../../utils/linkTarget.js";
import {
  ECTABlockButtonSizes
} from "./types.js";
export function useCTAButton(button) {
  return computed(
    () => button ? {
      label: button?.label,
      visualVariant: button?.visualVariant,
      size: button.size || ECTABlockButtonSizes.MEDIUM,
      action: button?.action,
      icon: button?.icon,
      target: getLinkTarget(button.action)
    } : void 0
  );
}
export function useCTALink(link) {
  return computed(
    () => link ? {
      label: link?.label,
      visualVariant: link?.visualVariant,
      size: link?.size || ECTABlockButtonSizes.MEDIUM,
      action: link?.action,
      icon: link?.icon,
      target: getLinkTarget(link?.action)
    } : void 0
  );
}
